import {defineStore} from "pinia";
import type {Page} from "@utils/models/page";
import type {Menu} from "@utils/models/menu";
import type {Wine,WineFull} from "@utils/models/wine";
import type {Collection} from "@utils/models/collection";
import type {Tooltip} from "@utils/models/tooltip";

export const usePagesStore = defineStore('pages',{
  state(){
    return{
      pagesList:[] as Page[],
      currentPage:null as null | string,
      hovered:null as null | string,
      tooltip: null as null | Tooltip,
      showVideo: false,
    }
  },
  getters:{
    getMenu(state):Menu {
      return {
        items: state.pagesList.map((item:Page)=>({
          title: item.menuTitle,
          href: item.code,
          active: state.currentPage === item.code
        }))
      }
    },
    getWineList(state): WineFull[]|any {
      return state.pagesList.filter((item: Page) => item.type === 'wine').map((item: Page) => ({
        title: item.menuTitle,
        code:item.code,
        ...item.data
      }))
    },
    getWineByCode(state):(code: string)=> WineFull|any {
      return (code:string)=> {
        const page = state.pagesList.find((item: Page) => item.code === state.currentPage);
        if (!page) {
          return undefined
        }
        return {
          title: page.menuTitle,
          code: page.code,
          ...page.data
        };
      }
    },
    getPageByCode(state):(code: string|null) => Page | undefined {
      return (code:string|null) => {
        if(code === 'index'){
          return undefined;
        }
        return state.pagesList.find((item:Page)=>item.code === code)
      };
    },
    getCurrentPage(state): Page | undefined {
        if(!state.currentPage){
          return undefined
        }
        return state.pagesList.find((item:Page)=>item.code === state.currentPage)
    },
    getNextWine(state){
      const wines = this.getWineList;
      const currentIndex = wines.findIndex((item:WineFull)=>item.code === state.currentPage);
      return currentIndex === (wines.length - 1) ? wines[0] : wines[currentIndex + 1];
    }
  },
  actions:{
    setPages(pages:Page[]){
      this.pagesList = pages
    },
    setPage(code:string){
      this.hovered = null;
      if(code === 'index'){
        this.currentPage = null;
        return;
      }
      const page = this.pagesList.find((item:Page)=>item.code === code);
      this.currentPage =  page? page.code : null
    },
    setHovered(code:string | null){
      this.hovered = code;
    },
    setTooltip(tooltip?:Tooltip){
      this.tooltip = tooltip ?? null
    }
  }
})